/* eslint-disable babel/camelcase */

export default function buildTicketSelectionLine(ticketTypeId, priceTypeId, ticketsCount) {
    return {
        ticket_type: ticketTypeId,
        price_type: priceTypeId,
        tickets_count: ticketsCount,
    };
}
